<template>
	<v-container class="mt-4 px-5" fluid>
	  <v-row v-if="( getdatosUsuarioERPERP.idpuesto == 18 && [568,626,7,1312,161,1248,1196,1489,1312,28,2910].includes( getdatosUsuarioERPERP.iderp ) ) || getdatosUsuarioERPERP.idpuesto != 18">
	  	<v-col cols="12">
	  		<v-card class="shadowCard entrada-teacher-card">
          <v-system-bar color="#08273B" dark height="48">
            <v-icon left>mdi-fingerprint</v-icon>
            <span class="text-subtitle-1 font-weight-medium">Visualizar entradas Teacher</span>
            <v-spacer></v-spacer>
            <span v-if="ultimaConsulta" class="text-caption mr-3 d-none d-sm-inline">
              Actualizado {{ ultimaConsulta }}
            </span>
            <v-btn small depressed color="white" class="primary--text" :loading="cargar" @click="getRol">
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-system-bar>

          <v-card-text class="pt-4 pb-6">
            <!-- Filtros -->
            <v-row dense align="center">
              <v-col cols="12" sm="5" md="4">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="ciclo"
                  :items="ciclos"
                  label="Ciclo"
                  hide-details
                  return-object
                  item-text="ciclo"
                  item-value="id_ciclo"
                />
              </v-col>
              <v-col cols="12" sm="7" md="5">
                <v-text-field
                  filled
                  dense
                  clearable
                  v-model="search"
                  label="Buscar teacher o plantel"
                  prepend-inner-icon="mdi-magnify"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="3" class="text-caption grey--text text-md-right">
                <div><v-icon x-small class="mr-1">mdi-calendar</v-icon> {{ fechaActualFormateada }}</div>
                <div v-if="ultimaActualizacion" class="mt-1">
                  Rol: {{ ultimaActualizacion.nombre_completo }}
                </div>
              </v-col>
            </v-row>

            <!-- KPIs -->
            <v-row dense class="mt-4 mb-2">
              <v-col cols="6" md="3">
                <div class="kpi-box kpi-box--total">
                  <v-icon color="#08273B" class="kpi-box__icon">mdi-account-group</v-icon>
                  <div>
                    <div class="kpi-box__num">{{ resumen.total }}</div>
                    <div class="kpi-box__label">Teachers hoy</div>
                  </div>
                </div>
              </v-col>
              <v-col cols="6" md="3">
                <div class="kpi-box kpi-box--ok">
                  <v-icon color="green darken-1" class="kpi-box__icon">mdi-fingerprint</v-icon>
                  <div>
                    <div class="kpi-box__num green--text text--darken-1">{{ resumen.presentes }}</div>
                    <div class="kpi-box__label">Con huella</div>
                  </div>
                </div>
              </v-col>
              <v-col cols="6" md="3">
                <div class="kpi-box kpi-box--pending">
                  <v-icon color="red darken-1" class="kpi-box__icon">mdi-clock-alert-outline</v-icon>
                  <div>
                    <div class="kpi-box__num red--text text--darken-1">{{ resumen.pendientes }}</div>
                    <div class="kpi-box__label">Sin huella</div>
                  </div>
                </div>
              </v-col>
              <v-col cols="6" md="3">
                <div class="kpi-box kpi-box--pct">
                  <v-icon color="blue darken-1" class="kpi-box__icon">mdi-chart-arc</v-icon>
                  <div class="flex-grow-1">
                    <div class="kpi-box__num blue--text text--darken-1">{{ resumen.porcentaje }}%</div>
                    <div class="kpi-box__label">Asistencia</div>
                    <v-progress-linear
                      :value="resumen.porcentaje"
                      height="6"
                      rounded
                      :color="resumen.porcentaje >= 80 ? 'green' : resumen.porcentaje >= 50 ? 'orange' : 'red'"
                      class="mt-1"
                    />
                  </div>
                </div>
              </v-col>
            </v-row>

            <!-- Filtro rápido -->
            <v-chip-group v-model="filtroEstado" mandatory class="mb-4" active-class="primary--text">
              <v-chip filter outlined small value="todos">Todos ({{ resumen.total }})</v-chip>
              <v-chip filter outlined small value="presentes" color="green" text-color="green darken-2">
                Con huella ({{ resumen.presentes }})
              </v-chip>
              <v-chip filter outlined small value="pendientes" color="red" text-color="red darken-2">
                Sin huella ({{ resumen.pendientes }})
              </v-chip>
            </v-chip-group>

            <v-alert v-if="!ciclo" type="info" outlined dense class="mb-0">
              Selecciona un ciclo para consultar las entradas del día.
            </v-alert>

            <v-row v-else>
              <v-col
                v-for="plantel in plantelesFiltrados"
                :key="plantel.id_plantel"
                cols="12"
                sm="6"
                lg="4"
              >
                <v-card outlined class="plantel-card fill-height d-flex flex-column">
                  <div class="plantel-card__header">
                    <div class="plantel-card__title text-truncate">{{ plantel.plantel }}</div>
                    <v-chip
                      x-small
                      :color="resumenPlantel(plantel.id_plantel).pendientes === 0 ? 'green' : 'orange darken-1'"
                      dark
                      class="ml-2 flex-shrink-0"
                    >
                      {{ resumenPlantel(plantel.id_plantel).presentes }}/{{ resumenPlantel(plantel.id_plantel).total }}
                    </v-chip>
                  </div>

                  <v-card-text class="pa-0 flex-grow-1">
                    <template v-if="teachersPorPlantel(plantel.id_plantel).length">
                      <div
                        v-for="teacher in teachersPorPlantel(plantel.id_plantel)"
                        :key="`${teacher.id_teacher}_${teacher.id_plantel}`"
                        class="teacher-row"
                        :class="{ 'teacher-row--ok': teacher.presente, 'teacher-row--pending': !teacher.presente }"
                        @click="abrirTelefonos(teacher)"
                      >
                        <div class="teacher-row__status">
                          <v-avatar size="32" :color="teacher.presente ? 'green lighten-5' : 'red lighten-5'">
                            <v-icon small :color="teacher.presente ? 'green darken-1' : 'red darken-1'">
                              {{ teacher.presente ? 'mdi-fingerprint' : 'mdi-account-clock' }}
                            </v-icon>
                          </v-avatar>
                        </div>
                        <div class="teacher-row__body">
                          <div class="teacher-row__name">{{ teacher.teacher }}</div>
                          <div v-if="teacher.presente" class="teacher-row__hora">
                            <v-icon x-small class="mr-1">mdi-clock-outline</v-icon>
                            Entrada · <strong>{{ formatearHoraHuella(teacher.horaAsistencia) }}</strong>
                          </div>
                          <div v-else class="teacher-row__hora teacher-row__hora--pending">
                            Sin registro de huella
                          </div>
                        </div>
                        <v-icon small color="grey lighten-1">mdi-chevron-right</v-icon>
                      </div>
                    </template>
                    <div v-else class="text-center py-6 grey--text text--lighten-1">
                      <v-icon large color="grey lighten-2">mdi-calendar-remove</v-icon>
                      <div class="text-caption mt-2">Sin clases hoy</div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>

          <!-- Detalle teacher -->
          <v-dialog v-model="dialogTelefonos" max-width="480">
            <v-card v-if="teacherSeleccionado">
              <v-card-title class="pb-2">
                <v-avatar size="40" :color="teacherSeleccionado.presente ? 'green lighten-4' : 'red lighten-4'" class="mr-3">
                  <v-icon :color="teacherSeleccionado.presente ? 'green darken-2' : 'red darken-2'">
                    {{ teacherSeleccionado.presente ? 'mdi-fingerprint' : 'mdi-account-clock' }}
                  </v-icon>
                </v-avatar>
                <div>
                  <div class="text-subtitle-1 font-weight-medium">{{ teacherSeleccionado.teacher }}</div>
                  <div class="text-caption grey--text">{{ nombrePlantelTeacher(teacherSeleccionado) }}</div>
                </div>
                <v-spacer></v-spacer>
                <v-btn icon @click="dialogTelefonos = false"><v-icon>mdi-close</v-icon></v-btn>
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text class="pt-4">
                <v-alert
                  v-if="teacherSeleccionado.presente"
                  dense
                  outlined
                  type="success"
                  class="mb-4"
                  icon="mdi-fingerprint"
                >
                  <div class="text-body-2">Huella registrada</div>
                  <div class="text-h6 font-weight-bold mt-1">
                    {{ formatearHoraHuella(teacherSeleccionado.horaAsistencia, true) }}
                  </div>
                </v-alert>
                <v-alert v-else dense outlined type="error" class="mb-4" icon="mdi-alert-circle-outline">
                  Aún no registra huella el día de hoy.
                </v-alert>

                <div class="text-subtitle-2 mb-2">
                  <v-icon small left>mdi-phone</v-icon>
                  Contacto
                </div>
                <v-data-table
                  v-if="telefonos.length"
                  :headers="headersTelefonos"
                  :items="telefonos"
                  class="elevation-0"
                  dense
                  hide-default-footer
                />
                <div v-else class="text-caption grey--text">Sin teléfonos registrados.</div>
              </v-card-text>
            </v-card>
          </v-dialog>
				</v-card>
		  </v-col>
	  </v-row>

    <Alerta v-if="respuestaAlerta" :parametros="parametros"/>
    <carga v-if="cargar"/>
	</v-container>
</template>
<script>
	import { mapGetters } from 'vuex'
  import Alerta from '@/components/alertas/Alerta.vue'
  import carga from '@/components/alertas/carga.vue'
  import validarErrores from '@/mixins/validarErrores'

  const DIAS_SEMANA = ['lu', 'ma', 'mi', 'ju', 'vi']
  const SEMANAS = [1, 2, 3, 4, 5]

  export default {
  	components: { Alerta, carga },
    mixins: [ validarErrores ],

    data: () => ({
    	parametros: { dialogError: false, mensaje: '', color: '' },
      fechaActual: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      respuestaAlerta: false,
      cargar: false,
      dialogTelefonos: false,
      filtroEstado: 'todos',
      ultimaConsulta: null,
      headersTelefonos: [
        { text: 'Nombre', value: 'nombre_completo' },
        { text: 'Tel. 1', value: 'telefono1' },
        { text: 'Tel. 2', value: 'telefono2' },
      ],
      search: '',
      ciclos: [],
      ciclo: null,
      planteles: [],
      ultimaActualizacion: null,
      teachersFiltros: [],
      rolReemplazo: [],
      telefonos: [],
      teacherSeleccionado: null,
    }),

    watch: {
      ciclo(val) {
        if (val) this.getRol()
      },
    },

    async created() {
      await this.initialize()
    },

    computed: {
      ...mapGetters('login', ['getdatosUsuarioERPERP', 'getLogeado']),

      fechaActualFormateada() {
        const partes = this.fechaActual.split('-')
        if (partes.length !== 3) return this.fechaActual
        const meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']
        const d = parseInt(partes[2], 10)
        const m = meses[parseInt(partes[1], 10) - 1] || partes[1]
        return `${d} ${m} ${partes[0]}`
      },

      teachersVisibles() {
        let lista = this.teachersFiltros

        if (this.filtroEstado === 'presentes') {
          lista = lista.filter((t) => t.presente)
        } else if (this.filtroEstado === 'pendientes') {
          lista = lista.filter((t) => !t.presente)
        }

        const q = (this.search || '').trim().toLowerCase()
        if (!q) return lista

        return lista.filter((t) => {
          const plantel = this.planteles.find((p) => p.id_plantel === t.id_plantel)
          const nombrePlantel = plantel ? plantel.plantel.toLowerCase() : ''
          return (t.teacher || '').toLowerCase().includes(q) || nombrePlantel.includes(q)
        })
      },

      plantelesFiltrados() {
        const ids = new Set(this.teachersVisibles.map((t) => t.id_plantel))
        const conTeachers = this.planteles.filter((p) => ids.has(p.id_plantel))
        if (!this.search && this.filtroEstado === 'todos') return this.planteles
        if (conTeachers.length) return conTeachers
        const q = (this.search || '').trim().toLowerCase()
        if (!q) return []
        return this.planteles.filter((p) => (p.plantel || '').toLowerCase().includes(q))
      },

      resumen() {
        const lista = this.teachersVisibles
        const presentes = lista.filter((t) => t.presente).length
        const total = lista.length
        const porcentaje = total > 0 ? Math.round((presentes / total) * 100) : 0
        return { total, presentes, pendientes: total - presentes, porcentaje }
      },
    },

    methods: {
      initialize() {
        this.cargar = true
        this.obtenerCiclos()
        this.getPlanteles()
      },

      formatearHoraHuella(horaRaw, completo) {
        if (!horaRaw) return '—'
        const str = String(horaRaw).trim()
        const match = str.match(/(\d{1,2}):(\d{2})(?::(\d{2}))?/)
        if (!match) return str

        let h = parseInt(match[1], 10)
        const min = match[2]
        const seg = match[3] || null
        const ampm = h >= 12 ? 'p.m.' : 'a.m.'
        const h12 = h % 12 || 12

        if (completo && str.length >= 10) {
          const fecha = str.slice(0, 10)
          const partes = fecha.split('-')
          if (partes.length === 3) {
            const horaTxt = seg ? `${h12}:${min}:${seg} ${ampm}` : `${h12}:${min} ${ampm}`
            return `${partes[2]}/${partes[1]}/${partes[0]} · ${horaTxt}`
          }
        }

        return seg ? `${h12}:${min}:${seg} ${ampm}` : `${h12}:${min} ${ampm}`
      },

      fechaHoyStr(fecha) {
        if (!fecha) return ''
        return String(fecha).trim().slice(0, 10)
      },

      parseHoraMinutos(horaRaw) {
        if (!horaRaw) return null
        const match = String(horaRaw).match(/(\d{1,2}):(\d{2})/)
        if (!match) return null
        return parseInt(match[1], 10) * 60 + parseInt(match[2], 10)
      },

      /** Sentinel en rol_clases_reemplazos: -1 (y 1202 histórico) = Sin Teacher a propósito. */
      esReemplazoSinTeacherExplicito(id) {
        if (id === null || id === undefined || id === '') return false
        const n = Number(id)
        return n === -1 || n === 1202
      },

      esSinTeacher(id, nombre) {
        if (id === null || id === undefined || id === '') return true
        const n = Number(id)
        // !id es true para 0, pero -1 es truthy en JS: hay que excluirlo explícito
        if (n === 0 || n === -1 || n === 1202) return true
        return !nombre || String(nombre).toUpperCase() === 'SIN TEACHER'
      },

      esIdTeacherValido(id) {
        if (id === null || id === undefined || id === '') return false
        const n = Number(id)
        return Number.isFinite(n) && n > 0 && n !== 1202
      },

      buildReemplazoByGrupo(rolReemplazo) {
        const mapa = {}
        for (const r of rolReemplazo || []) {
          if (r && r.idgrupo != null) mapa[Number(r.idgrupo)] = r
        }
        return mapa
      },

      /** Misma prioridad que rol.clases: reemplazo → rol oficial (row) → LMS ya fusionado en row. */
      resolverTeacherSlot(row, reemplazo, slot) {
        const repId = reemplazo && reemplazo[slot]
        const repNom = reemplazo && reemplazo[`${slot}_n`]

        // -1/1202 en reemplazo: NO caer al teacher del row (Sonia del rol/LMS)
        if (this.esReemplazoSinTeacherExplicito(repId)) {
          return null
        }

        if (this.esIdTeacherValido(repId)) {
          let nombre = repNom && String(repNom).toUpperCase() !== 'SIN TEACHER' ? repNom : null
          if (!nombre && Number(row[slot]) === Number(repId)) {
            nombre = row[`${slot}_n`]
          }
          if (nombre && String(nombre).toUpperCase() !== 'SIN TEACHER') {
            return { idTeacher: Number(repId), nombre, esReemplazo: true }
          }
        }

        const id = row[slot]
        const nombre = row[`${slot}_n`]
        if (!this.esSinTeacher(id, nombre)) {
          return { idTeacher: id, nombre, esReemplazo: false }
        }

        return null
      },

      buscarHoraAsistenciaEnRow(row, idTeacher, slotPreferido, hoy, esReemplazo = false) {
        const idBuscado = Number(idTeacher)
        const slotDirecto = row[slotPreferido]
        if (Number(slotDirecto) === idBuscado) {
          const fechaSlot = this.fechaHoyStr(row[`${slotPreferido}_fecha`])
          const hora = row[`${slotPreferido}_hora_asistencia`] || ''
          if (fechaSlot === hoy && hora) return hora
        }

        for (const sem of SEMANAS) {
          for (const dia of DIAS_SEMANA) {
            const s = `${dia}${sem}`
            if (this.fechaHoyStr(row[`${s}_fecha`]) !== hoy) continue
            if (Number(row[s]) !== idBuscado) continue
            const hora = row[`${s}_hora_asistencia`] || ''
            if (hora) return hora
          }
        }

        // Reemplazo: huella del bloque de hoy aunque row[slot] aún tenga al oficial (desfase API)
        if (esReemplazo) {
          const fechaSlot = this.fechaHoyStr(row[`${slotPreferido}_fecha`])
          const horaSlot = row[`${slotPreferido}_hora_asistencia`] || ''
          if (fechaSlot === hoy && horaSlot) return horaSlot
        }

        return ''
      },

      extraerTeachersHoy(respuesta, rolReemplazo) {
        const mapa = {}
        const hoy = this.fechaActual
        const reemplazoByGrupo = this.buildReemplazoByGrupo(rolReemplazo)

        for (const row of respuesta || []) {
          if (row.deleted !== 0) continue

          const reemplazo = reemplazoByGrupo[row.iderp]

          for (const sem of SEMANAS) {
            for (const dia of DIAS_SEMANA) {
              const slot = `${dia}${sem}`
              const fechaSlot = this.fechaHoyStr(row[`${slot}_fecha`])
              if (fechaSlot !== hoy) continue

              const teacher = this.resolverTeacherSlot(row, reemplazo, slot)
              if (!teacher) continue

              const { idTeacher, nombre, esReemplazo } = teacher
              const horaAsistencia = this.buscarHoraAsistenciaEnRow(row, idTeacher, slot, hoy, esReemplazo)
              const key = `${idTeacher}_${row.id_plantel}`

              if (!mapa[key]) {
                mapa[key] = {
                  id_teacher: idTeacher,
                  teacher: nombre,
                  id_plantel: row.id_plantel,
                  horaAsistencia: horaAsistencia,
                  presente: !!horaAsistencia,
                  telefonos: [],
                }
              } else if (horaAsistencia) {
                const actual = this.parseHoraMinutos(mapa[key].horaAsistencia)
                const nueva = this.parseHoraMinutos(horaAsistencia)
                if (!mapa[key].presente || (nueva != null && (actual == null || nueva < actual))) {
                  mapa[key].horaAsistencia = horaAsistencia
                }
                mapa[key].presente = true
              }
            }
          }
        }

        return Object.values(mapa).sort((a, b) => {
          if (a.presente !== b.presente) return a.presente ? -1 : 1
          return (a.teacher || '').localeCompare(b.teacher || '', 'es')
        })
      },

      teachersPorPlantel(idPlantel) {
        return this.teachersVisibles.filter((t) => t.id_plantel === idPlantel)
      },

      resumenPlantel(idPlantel) {
        const lista = this.teachersPorPlantel(idPlantel)
        const presentes = lista.filter((t) => t.presente).length
        return { total: lista.length, presentes, pendientes: lista.length - presentes }
      },

      nombrePlantelTeacher(teacher) {
        const p = this.planteles.find((pl) => pl.id_plantel === teacher.id_plantel)
        return p ? p.plantel : '—'
      },

      abrirTelefonos(teacher) {
        this.teacherSeleccionado = teacher
        this.telefonos = teacher.telefonos && teacher.telefonos.length ? teacher.telefonos : []
        this.dialogTelefonos = true
      },

      getTelefonos(idTeachers) {
        if (!idTeachers || !idTeachers.length) return Promise.resolve()
        return this.$http.post('teachers.telefonos', idTeachers).then((response) => {
          const porId = {}
          for (const t of response.data || []) {
            if (!porId[t.id]) porId[t.id] = []
            porId[t.id].push(t)
          }
          this.teachersFiltros.forEach((el) => {
            el.telefonos = porId[el.id_teacher] || []
          })
        }).catch((error) => {
          this.validarError(error.response && error.response.data ? error.response.data.message : 'Error al cargar teléfonos')
        })
      },

      getRol() {
        if (!this.ciclo) {
          return this.validarErrorDirecto('Selecciona un ciclo')
        }
        this.cargar = true
        this.fechaActual = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
        this.$http.post('rol.clases', this.ciclo).then((response) => {
          this.ultimaActualizacion = response.data.ultimaActualizacion || null
          this.rolReemplazo = response.data.rolReemplazo || []
          this.teachersFiltros = this.extraerTeachersHoy(response.data.respuesta, this.rolReemplazo)
          this.ultimaConsulta = new Date().toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })
          const ids = [...new Set(this.teachersFiltros.map((el) => el.id_teacher))]
          return this.getTelefonos(ids)
        }).catch((error) => {
          this.validarError(error.response && error.response.data ? error.response.data.message : 'Error al consultar rol')
        }).finally(() => {
          this.cargar = false
        })
      },

      obtenerCiclos() {
        this.ciclos = []
        this.$http.get('roles.ciclos.all').then((response) => {
          for (const i in response.data) {
            if (!(response.data[i].ciclo.search('FE') != -1)) {
              if (response.data[i].ciclo.search('CICLO') != -1) {
                this.ciclos.push(response.data[i])
              }
            }
          }
        }).catch((error) => {
          this.validarError(error.response && error.response.data ? error.response.data.message : 'Error al cargar ciclos')
        }).finally(() => {
          this.cargar = false
        })
      },

      getPlanteles() {
        this.planteles = []
        return this.$http.get('planteles.activos').then((response) => {
          this.planteles = response.data.filter((el) =>
            ![13, 15, 18, 19, 20, 10006, 10007, 10008, 10009, 10010, 10011, 10012, 10013, 10014, 10002].includes(el.id_plantel)
          )
        }).catch((error) => {
          this.validarError(error.response && error.response.data ? error.response.data.message : 'Error al cargar planteles')
        })
      },
    },
  }
</script>

<style scoped>
.entrada-teacher-card {
  overflow: hidden;
}

.kpi-box {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
  height: 100%;
}

.kpi-box--total { background: #f5f8fa; }
.kpi-box--ok { background: #f1f8f2; border-color: #c8e6c9; }
.kpi-box--pending { background: #fef5f5; border-color: #ffcdd2; }
.kpi-box--pct { background: #f3f7fc; border-color: #bbdefb; }

.kpi-box__icon { flex-shrink: 0; }
.kpi-box__num { font-size: 1.5rem; font-weight: 700; line-height: 1.2; }
.kpi-box__label { font-size: 0.75rem; color: #757575; }

.plantel-card {
  border-radius: 10px;
  overflow: hidden;
}

.plantel-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: #08273B;
  color: #fff;
}

.plantel-card__title {
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.teacher-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background 0.15s;
}

.teacher-row:last-child { border-bottom: none; }
.teacher-row:hover { background: #fafafa; }

.teacher-row--ok { border-left: 3px solid #43A047; }
.teacher-row--pending { border-left: 3px solid #E53935; }

.teacher-row__body { flex: 1; min-width: 0; }

.teacher-row__name {
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.3;
  color: #212121;
}

.teacher-row__hora {
  font-size: 0.75rem;
  color: #2e7d32;
  margin-top: 2px;
  display: flex;
  align-items: center;
}

.teacher-row__hora--pending {
  color: #c62828;
  font-style: italic;
}
</style>
